import * as React from 'react';

import IdealUpgradeEnrollModal from 'bundles/coursera-plus-common/components/subscriptionTiers/upgradeToPlus/IdealUpgradeEnrollModal';
import IndiaPriceTestUpgradeModal from 'bundles/coursera-plus-common/components/subscriptionTiers/upgradeToPlus/IndiaUpgrade/IndiaPriceTestUpgradeModal';
import { getIsLearnerImpressedInIndiaTiersEpic } from 'bundles/coursera-plus-common/utils/subscriptionTiersUtils';
import { productPriceToMonetaryAmount } from 'bundles/coursera-plus-landing-page/utils/productPriceToMonetaryAmount';
import usePageData from 'bundles/enroll/data/usePageData';

type PropsFromCaller = {
  selectedStep?: 1 | 2 | 3;
  onClose: () => void;
  courseId?: string;
};

const IdealUpgradeEnrollModalContainer = ({ onClose, courseId, selectedStep }: PropsFromCaller) => {
  const { s12n, courseraPlusMonthlyProductPrice: courseraPlusProductPrice } = usePageData();

  if (getIsLearnerImpressedInIndiaTiersEpic()) {
    return <IndiaPriceTestUpgradeModal onClose={onClose} />;
  }

  const productPrice = courseraPlusProductPrice ? productPriceToMonetaryAmount(courseraPlusProductPrice) : undefined;

  return (
    <IdealUpgradeEnrollModal
      courseraPlusProductPrice={productPrice}
      onClose={onClose}
      courseId={courseId}
      s12nId={s12n?.id}
      selectedStep={selectedStep}
    />
  );
};

export default IdealUpgradeEnrollModalContainer;
